/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedSubscriptionRequestDto } from '../../models/backend-patched-subscription-request-dto';
import { BackendSubscriptionDto } from '../../models/backend-subscription-dto';

export interface SubscriptionActivePartialUpdate$Params {
  body?: BackendPatchedSubscriptionRequestDto;
}

export function subscriptionActivePartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionActivePartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionActivePartialUpdate.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSubscriptionDto>;
    }),
  );
}

subscriptionActivePartialUpdate.PATH = '/api/subscription/active/';
